import React from "react";
import { AddressForm, Box, Stack, Text, Title } from "@thecb/components";

const InlineBillingAddressSection = ({
  addressForm,
  addressFormActions,
  showErrors = false
}) => {
  return (
    <Box padding="0">
      <Stack childGap="0.5rem">
        <Title variant="small" as="h3">
          Add New Billing Address
        </Title>
        <Text variant="p">
          A billing address is also required to set up autopay. Add your billing
          address details below.
        </Text>
      </Stack>
      <Box padding="0" extraStyles="margin: 0 -1rem;">
        <AddressForm
          {...addressForm}
          {...addressFormActions}
          showErrors={showErrors}
        />
      </Box>
    </Box>
  );
};

export default InlineBillingAddressSection;
